// Unsaved editor texts in localStorage, so they survive closing the modal or a reload.
// Keys look like "owner/repo#12:new" (see Detail); saving or cancelling removes them.
const PREFIX = 'draft:'
const MAX_AGE_MS = 30 * 86_400_000
// an upload still running when the page went away will never finish
const UPLOADING = /!\[Uploading [^\]]*…\]\(\)\n?/g

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(PREFIX + key))
  } catch {
    return null
  }
}

export const drafts = {
  get(key) {
    const draft = key && read(key)
    return draft ? draft.text.replace(UPLOADING, '') : null
  },
  set(key, text) {
    if (!key) return
    try {
      localStorage.setItem(
        PREFIX + key,
        JSON.stringify({ text, at: Date.now() })
      )
    } catch {
      // storage unavailable (private mode, blocked): works without it
    }
  },
  remove(key) {
    try {
      if (key) localStorage.removeItem(PREFIX + key)
    } catch {
      // storage unavailable (private mode, blocked): works without it
    }
  },
}

// forget old drafts once per page load
try {
  for (const key of Object.keys(localStorage)) {
    if (
      key.startsWith(PREFIX) &&
      !(read(key.slice(PREFIX.length))?.at > Date.now() - MAX_AGE_MS)
    )
      localStorage.removeItem(key)
  }
} catch {
  // storage unavailable (private mode, blocked): works without it
}
